import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { OrderStatusRequestImpl } from "../model/impl/OrderStatusRequestImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class OrderStatusRequestImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: OrderStatusRequestImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(1),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.branchCds != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(2),
        false,
        encodable.branchCds,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.ccyPairs != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(3),
        false,
        encodable.ccyPairs,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(4),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.entryComparitor != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(5),
        true,
        encodable.entryComparitor,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserCd != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(6),
        false,
        encodable.entryUserCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.expiryComparitor != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(7),
        true,
        encodable.expiryComparitor,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.fillComparitor != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(8),
        true,
        encodable.fillComparitor,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(9),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.orderIds != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(10),
        false,
        encodable.orderIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.orderStates != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(11),
        false,
        encodable.orderStates,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.orderTypes != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(12),
        false,
        encodable.orderTypes,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.products != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(13),
        false,
        encodable.products,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupIds != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderStatusRequestImplEncoder.fidTypeMap.get(14),
        false,
        encodable.salesGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.lastUpdateComparitor != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(15),
        true,
        encodable.lastUpdateComparitor,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.oboEntryUser != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(16),
        false,
        encodable.oboEntryUser,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(17),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.oboClient != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(18),
        false,
        encodable.oboClient,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.brokerId != null) {
      this.baseEncoder.writeStartFid(200, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(200),
        false,
        encodable.brokerId,
        streamout,
      );
      this.baseEncoder.writeEndFid(200, streamout);
    }
    /*Object encoding*/
    if (encodable.secureToken != null) {
      this.baseEncoder.writeStartFid(300, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(300),
        true,
        encodable.secureToken,
        streamout,
      );
      this.baseEncoder.writeEndFid(300, streamout);
    }
    /*Object encoding*/
    if (encodable.proxySessionId != null) {
      this.baseEncoder.writeStartFid(999, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(999),
        false,
        encodable.proxySessionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(999, streamout);
    }
    /*Object encoding*/
    if (encodable.svrRxTime != null) {
      this.baseEncoder.writeStartFid(10000, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(10000),
        false,
        encodable.svrRxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10000, streamout);
    }
    /*Object encoding*/
    if (encodable.svrTxTime != null) {
      this.baseEncoder.writeStartFid(10001, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(10001),
        false,
        encodable.svrTxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10001, streamout);
    }
    /*Object encoding*/
    if (encodable.cliTxTime != null) {
      this.baseEncoder.writeStartFid(10002, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(10002),
        false,
        encodable.cliTxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10002, streamout);
    }
    /*Object encoding*/
    if (encodable.cliRxTime != null) {
      this.baseEncoder.writeStartFid(10003, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(10003),
        false,
        encodable.cliRxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10003, streamout);
    }
    /*Object encoding*/
    if (encodable.con != null) {
      this.baseEncoder.writeStartFid(99999, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderStatusRequestImplEncoder.fidTypeMap.get(99999),
        false,
        encodable.con,
        streamout,
      );
      this.baseEncoder.writeEndFid(99999, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,OrderStatusRequestImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "com.bcdfx.model.DateComparitor"],
    [6, "java.lang.String"],
    [7, "com.bcdfx.model.DateComparitor"],
    [8, "com.bcdfx.model.DateComparitor"],
    [9, "java.lang.String"],
    [10, "java.lang.String"],
    [11, "com.bcdfx.model.OrderStateFilter"],
    [12, "com.bcdfx.model.RequestOrderType"],
    [13, "com.bcdfx.model.Product"],
    [14, "java.lang.Long"],
    [15, "com.bcdfx.model.DateComparitor"],
    [16, "java.lang.String"],
    [17, "java.lang.String"],
    [18, "java.lang.String"],
    [100, "java.lang.String"],
    [200, "java.lang.String"],
    [300, "com.bcdfx.security.SecureToken"],
    [999, "java.lang.String"],
    [10000, "java.lang.Long"],
    [10001, "java.lang.Long"],
    [10002, "java.lang.Long"],
    [10003, "java.lang.Long"],
    [99999, "com.bcdfx.model.query.Condition"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: OrderStatusRequestImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.branchCds = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.ccyPairs = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.DateComparitor = this.baseEncoder.readObject(
            true,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.entryComparitor = <CubiqTS.DateComparitor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.entryUserCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.DateComparitor = this.baseEncoder.readObject(
            true,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.expiryComparitor = <CubiqTS.DateComparitor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.DateComparitor = this.baseEncoder.readObject(
            true,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.fillComparitor = <CubiqTS.DateComparitor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.orderId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.orderIds = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<CubiqTS.OrderStateFilter> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.orderStates = <Array<CubiqTS.OrderStateFilter>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: Array<CubiqTS.RequestOrderType> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.orderTypes = <Array<CubiqTS.RequestOrderType>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: Array<CubiqTS.Product> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.products = <Array<CubiqTS.Product>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            OrderStatusRequestImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.salesGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.DateComparitor = this.baseEncoder.readObject(
            true,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.lastUpdateComparitor = <CubiqTS.DateComparitor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.oboEntryUser = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.oboClient = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 200: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(200),
            streamin,
          );
          encodable.brokerId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 300: {
          /*Object encoding*/
          let val: CubiqTS.SecureToken = this.baseEncoder.readObject(
            true,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(300),
            streamin,
          );
          encodable.secureToken = <CubiqTS.SecureToken>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 999: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(999),
            streamin,
          );
          encodable.proxySessionId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10000: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(10000),
            streamin,
          );
          encodable.svrRxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10001: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(10001),
            streamin,
          );
          encodable.svrTxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10002: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(10002),
            streamin,
          );
          encodable.cliTxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10003: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(10003),
            streamin,
          );
          encodable.cliRxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 99999: {
          /*Object encoding*/
          let val: CubiqTS.Condition = this.baseEncoder.readObject(
            false,
            false,
            OrderStatusRequestImplEncoder.fidTypeMap.get(99999),
            streamin,
          );
          encodable.con = <CubiqTS.Condition>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,OrderStatusRequestImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return OrderStatusRequestImplEncoder.fidTypeMap.has(fid);
  }
}
